import React from 'react';
import classNames from 'classnames';
import { validUrl } from '../../utils/validator';
import arrow from '../../images/arrow.svg';

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.handleSearchUrlChange = this.handleSearchUrlChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = { url: props.url, lastSentUrl: '', valid: true };
  }

  componentDidMount() {
    if(!this.props.currentStep) {
      this.refs.search.focus();
    }
  }

  handleSearchUrlChange(event) {
    let url = event.target.value;
    this.setState({ url: url });
    if(url === '' || (validUrl(url) && !this.state.valid)) {
      this.setState({ valid: true });
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    if(this.state.url.slice(-1) === '/') {
      this.setState({url: this.state.url.slice(0, -1)}, () => this.submitUrl());
    } else {
      this.submitUrl();
    }
  }

  submitUrl() {
    let url = this.state.url.trim().toLowerCase();
    if(url !== this.state.lastSentUrl) {
      if(validUrl(url)) {
        this.setState({lastSentUrl: url});
        this.refs.search.blur();
        this.props.onComplete({url: url, reset: this.props.currentStep !== 0});
      } else {
        this.setState({valid: false});
      }
    }
  }

  render() {
    let inputClassName = classNames(
      'search__input',
      {'is-invalid': !this.state.valid}
    );
    return (
      <form className="search" onSubmit={this.handleSubmit}>
        <div className="search__title"><img className="pen-arrow left" src={arrow}/>Test Your Site Here<img className="pen-arrow right" src={arrow}/></div>
        <input
          type="text"
          className={inputClassName}
          placeholder="Enter URL here..."
          value={this.state.url}
          onChange={this.handleSearchUrlChange}
          ref="search" />
        <div className="search__hook">Is your site as fast and secure as it could be?</div>
        <div className="search__intro">
          <p className="intro-text-paragraph"><strong>Testmysite.io rates your site based on its initial global load times and its security settings.</strong></p>
          <p className="intro-text-paragraph">Even a very optimized site made on a legacy stack like Wordpress can often become several seconds faster by being built in a modern way and served via a service such as Netlify. By using HTTPS and HTTP2 you can improve both speed and search ranking.</p>
        </div>
      </form>
    );
  }
}

Search.propTypes = {
  url: React.PropTypes.string,
  currentStep: React.PropTypes.number,
  onComplete: React.PropTypes.func
};

export default Search;



// WEBPACK FOOTER //
// ./src/components/common/Search.js